module.exports = __webpack_public_path__ + "static/media/elchivo-banner.8baf0688.jpg";